// src/components/InventoryBar.js
function compress(inv=[]) {
  const map = {};
  for (const it of inv) {
    const key = it.name || it.id;
    map[key] = (map[key] || 0) + 1;
  }
  return Object.entries(map).map(([name, n]) => n>1 ? `${name} x${n}` : name);
}

export default function InventoryBar({ progress }) {
  const need = 50 + (progress.level-1)*25;
  const items = compress(progress.inv);

  return (
    <div className="invbar">
      <span>Wave <b>{progress.wave}</b></span>
      <span>Gold <b>{progress.gold}</b></span>
      <span>Lv <b>{progress.level}</b> · XP {progress.xp}/{need}</span>
      {items.length ? <span>Items: {items.join(', ')}</span> : <span>Items: —</span>}
    </div>
  );
}
